import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    status: { type: Number, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { status: number }



const computedStatus = computed(() => {
    switch (props.status) {
        case 1:
            return "Te koop";
            break;
        case 2:
            return "Te huur";
            break;
        case 3:
            return "Verkocht";
            break;
        case 3:
            return "Verhuurd";
            break;
    }
    return "";
});

const __returned__ = { props, computedStatus }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})